import { Dispatch } from "react";
import { useFormContext } from "react-hook-form";
import { UserLoginErrorCode } from "common-client/generated/graphql";
import { MFAFlowAction } from "common-client/utils/useMFAFlow";
import { useVerifyAdminTotpMutation } from "../../../generated/graphql";
import { ProvideCode } from "../CommonLoginComponents/ProvideCode";
import { LoginFormStructure } from "../LoginPage";
import { isValidTotpCode, verifyLoginData } from "./utils";

export const SetupFlowCode = ({
  onLoginSuccess,
  dispatch,
  qrCode,
  error,
}: {
  onLoginSuccess: () => void;
  dispatch: Dispatch<MFAFlowAction>;
  qrCode?: Maybe<string>;
  error: Maybe<{ message: string; code?: UserLoginErrorCode }>;
}) => {
  const { watch } = useFormContext();
  const code = watch("code");

  const [verifyTotpCode, { loading }] = useVerifyAdminTotpMutation();

  const onSubmit = async (loginData: LoginFormStructure) => {
    if (!verifyLoginData(loginData, dispatch)) {
      return;
    }

    await verifyTotpCode({
      variables: {
        data: {
          email: loginData.email,
          password: loginData.password,
          totpToken: loginData.code,
        },
      },
      onCompleted: data => {
        if (data.verifyAdminTotp?.ok) {
          onLoginSuccess();
        } else {
          dispatch({
            type: "setupFlowTotpCode",
            data: { ...data.verifyAdminTotp, qrCode },
          });
        }
      },
    });
  };

  const disabled = !isValidTotpCode(code) || loading;

  return (
    <ProvideCode
      title="Enter authentication code"
      subtitle="Enter the 6-digit code from your authenticator app; the code refreshes every 30 seconds."
      onSubmit={onSubmit}
      onBack={() => {
        dispatch({
          type: "setupTotp",
          data: { qrCode, ok: true, error: null },
        });
      }}
      disabled={disabled}
      error={error}
    />
  );
};
